import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const modelliStampa: AnaColumn[] = [

    {

        itemType: "group", colCount: "1",class:'float-end', data: [
          { dataField: "nomeModello",caption:'Nome Modello' , type: 'campo', colVisible: true, dataType: "", hideOnEdit: true, },
       

          { type: 'empty', dataField: '', colVisible: false, dataType: '' },


          {
            type: 'campoSpecial',
            colVisible: true,
            dataField: "idCategoriaModello",
            editorType: 'dxLookup',
            width: 24.2 +'vw',
            caption: "Categoria Modello",
              
            lista: {
              valueExpr: 'id',
              queryString: '',
              displayExpr: 'descrizione',
              dataSource: "CategoriaModello",
              static: false,
              //cascading: ['id|idAutomezzo','idSoggetto|idAlbo','idSoggetto|idAutista'], 
              colonne: [
                /*
                {
                  dataField: 'id',
                  caption: 'Codice',
                  width:80,
                  alignment:'left'
                },
                */
                {
                  dataField: 'descrizione',
                  caption: 'Descrizione'
    
                },
     
              ]
    
            },
            /*
            validation: [
              { type: 'required', message: 'Campo obbligatorio' }
            ]
            */
    
          },

          /*

           Button lente di ingrandimento
          */
          {
            type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
    
            button: {
              name: 'stampaModello',
              hint: 'Stampa Modello',
              icon: 'search',
              text: 'Stampa Modello',
              type: 'text',
              event: 'stampaModello'
            }
          },
          
          /*
          {
            type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
    
            button: {
              name: 'scaricaAllegato',
              hint: 'Scarica Allegato',
              icon: 'download',
              text: 'Scarica',
              type: 'text',
              event: 'scaricaAllegato'
            }
          },
          */
        ]

    }






]